<template>
  <div class>
    <!-- header start -->
    <van-nav-bar
      title="提现记录"
      left-arrow
      fixed
      :z-index="99"
      @click-left="onClickLeft"
      :border="false"
    />
    <div class="navBarSpace"></div>
    <!-- header end -->
    <van-pull-refresh v-if="dataList!=null" v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        :offset="offset"
        :immediate-check="ischeck"
        finished-text="没有更多了"
        @load="loadMore"
      >
        <div class="recharge-list">
          <div class="van-hairline--bottom">
            <van-row gutter="10" class="thead">
              <van-col span="5">交易号</van-col>
              <van-col span="5">
                <div class="price">交易金额(元)</div>
              </van-col>
              <van-col span="4">
                <div>状态</div>
              </van-col>
              <van-col span="4">
                <div>备注</div>
              </van-col>
              <van-col span="5">
                <div class="date">交易时间</div>
              </van-col>
            </van-row>
          </div>

          <div class="van-hairline--bottom" v-for="(item,index) in dataList" :key="index">
            <van-row gutter="10" class="tbody">
              <van-col span="5">
                 <div class="code">{{item.TransactionOrderlID}}</div>
              </van-col>
            <van-col span="5">
              <div class="price">{{item.Cash}}</div>
            </van-col>
            <van-col span="4">
              <div v-if="item.WithdrawStatus!=1" style="color:red"  >{{getWithdrawStatusText(item.WithdrawStatus)}}</div>
              <div v-else style="color:green" >{{getWithdrawStatusText(item.WithdrawStatus)}}</div>
            </van-col>
            <van-col span="4">
              <div class="code" >{{item.Remarks}}</div>
            </van-col>
            <van-col span="5">
              <div class="date">{{item.AddDateTime}}</div>
            </van-col>
            </van-row>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
export default {
  data() {
    return {
      refreshing: false,
      loading: true,
      finished: false,
      offset: 100,
      ischeck: false,
      options: null,
      dataList: []
    };
  },
  components: {},
  mounted() {
    document
      .querySelector("body")
      .setAttribute("style", "background-color:#f2f2f2");
    this.init();
  },
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  },
  methods: {
    init() {
      var that = this;
      that.options = {
        type: "GetDistributionWithdrawApiModelListSearch",
        pageIndex: 1
      };
      that.getList();
    },
    loadMore() {
      Object.assign(this.options, {
        pageIndex: this.options.pageIndex + 1
      });
      this.loading = true;
      this.getList();
    },
    onRefresh() {
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      Object.assign(this.options, {
        pageIndex: 1
      });
      this.getList();
    },
    getList() {
      var that = this;
      that.$store.dispatch(this.options).then(
        res => {
          that.loading = false;
          if (that.refreshing) {
            that.refreshing = false;
          }
          if (res.DistributionWithdrawApiModelList.length <= 0) {
            that.finished = true;
          }
          if (this.options.pageIndex > 1) {
            if (res.DistributionWithdrawApiModelList.length > 0) {
              res.DistributionWithdrawApiModelList.forEach(element => {
                that.dataList.push(element);
              });
            }
          } else {
            that.dataList = res.DistributionWithdrawApiModelList;
          }
        },
        error => {}
      );
    },
    getWithdrawStatusText(status){
      var _text="未知";
      switch(status){
        case 0:
          _text="审核中";
          break;
        case 1:
          _text="提现成功";
          break;
        case 2:
          _text="审核不通过";
          break;
      }
      return _text;
    },
    onClickLeft() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.recharge-list {
  background-color: #fff;
  overflow: hidden;
}
.recharge-list .tbody,
.recharge-list .thead {
  padding: 10px;
}
.recharge-list .thead {
  font-size: 13px;
  color: #888;
  padding-top: 20px;
}
.recharge-list .date {
  text-align: right;
}
.recharge-list .tbody .date {
  color: #999;
  font-size: 12px;
}
.recharge-list .price {
  text-align: center;
}
.recharge-list .tbody .price {
  font-size: 14px;
}
.recharge-list .tbody .code {
  font-size: 12px;
  word-break: break-all;
  word-wrap: break-word;
  overflow: hidden;
}
</style>
